import styled from 'styled-components';
import { SidebarMenuItemContainer } from '../SidebarMenuItem/styled.js';
import { SIDEBAR_PADDING } from '../config.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var NEGATIVE_SPACING = "calc((" + SIDEBAR_PADDING + " / 2) * -1)";
var POSITIVE_SPACING = "calc(" + SIDEBAR_PADDING + " / 2)";
var SidebarMenuUserContainer = styled(SidebarMenuItemContainer).withConfig({
  displayName: "SidebarMenuUserContainer",
  componentId: "sc-1ws4zjh-0"
})(["margin:", ";padding:", ";width:calc(100% + ", ");", ""], NEGATIVE_SPACING, POSITIVE_SPACING, SIDEBAR_PADDING, function (props) {
  return props.$minimized && "\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    border-radius: 50%;\n  ";
});
var TextContainer = styled.div.withConfig({
  displayName: "TextContainer",
  componentId: "sc-1ws4zjh-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:flex-start;max-width:100%;overflow:hidden;margin-left:", ";"], themeGet('spacing.sm'));

export { SidebarMenuUserContainer, TextContainer };
